import React, { useState } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";

import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";

import Error from "components/form/Error";

import DrawerButton from "components/form/DrawerButton";
import SelectParent from "components/form/SelectParent";
import SelectSubparent from "components/form/SelectSubparent";
import useMenuSubmit from "hooks/useMenuSubmit";

const MenuDrawer = ({ id }) => {
  const [selectedParentId, setSelectedParentId] = useState(); // Store selected parent ID
  const {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    allSubparent,
    allParent,

    errors,
  } = useMenuSubmit(id, setSelectedParentId);

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit Menu" />
        ) : (
          <Title register={register} title="Add Menu" />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <div className="col-span-6">
                    <LabelArea label="Parent Name" />
                    <SelectParent
                      register={register}
                      value={selectedParentId}
                      name="id_parent"
                      label="Parent Name"
                      allParent={allParent}
                      onChange={(e) => setSelectedParentId(e.target.value)}
                      errors={errors}
                    />
                    <Error errorName={errors.id_parent} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Sub Parent Name" />
                    <SelectSubparent
                      register={register}
                      // handleReferenceNoChange={(value) => console.log('Selected Vehicle ID:', value)}
                      name="id_sub_parent"
                      label="Sub Parent Name"
                      allParent={allSubparent}
                      id_parent={selectedParentId}
                      errors={errors}
                    />
                    <Error errorName={errors.id_sub_parent} />
                  </div>
                  <div className="col-span-6">
                    <LabelArea label="name" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="name"
                      name="name"
                      type="text"
                      placeholder="name"
                      //  pattern={/^[A-Za-z]+$/}
                    />
                    <Error errorName={errors.name} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Path" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="path"
                      name="path"
                      type="text"
                      placeholder="path"
                    />
                    <Error errorName={errors.path} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="position" required />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="position"
                      name="position"
                      type="number"
                      placeholder="position"
                    />
                    <Error errorName={errors.position} />
                  </div>
                  <div className="col-span-6">
                    <LabelArea label="icon" />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="icon"
                      name="icon"
                      type="text"
                      placeholder="icon"
                      required={false}
                    />
                    <Error errorName={errors.icon} />
                  </div>
                </div>
              </div>

              <DrawerButton id={id} title={id ? "Update" : "Submit"} />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default MenuDrawer;
